module.exports = __webpack_public_path__ + "static/media/scorecard.ce25b52c.svg";